import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import type { MenuProps } from 'antd';
import { Dropdown, Flex, Modal } from 'antd';
import { ExclamationCircleOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { routePaths } from 'router';
import { cleanTokens } from 'services/auth';
import { useAuthStore } from 'shared/stores';
import type { TDropdownChangeInfo } from 'types/dropdown-change-info';

interface IProfileProps {
  userName?: string;
}

export const Profile: React.FC<IProfileProps> = (props) => {
  const { userName } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { clearAuth } = useAuthStore();

  const [modal, contextHolder] = Modal.useModal();
  const [isActiveControl, setIsActiveControl] = useState(false);
  const deactivateWithTimeout = () => {
    setTimeout(() => setIsActiveControl(false), 300);
  };

  const confirm = () => {
    modal.confirm({
      title: t('common:logout'),
      icon: <ExclamationCircleOutlined />,
      content: t('common:logout_confirm_text'),
      okText: t('common:logout'),
      cancelText: t('common:cancel'),
      onCancel: () => deactivateWithTimeout(),
      onOk: async () => {
        clearAuth();
        cleanTokens();
        navigate(routePaths.auth);
        deactivateWithTimeout();
      },
    });
  };

  const handleDropdownClick: MenuProps['onClick'] = ({ key }) => {
    if (key === 'logout') {
      confirm();
    }
  };

  const handleDropdownOpenChange = (value: boolean, info: TDropdownChangeInfo) => {
    if (info.source === 'trigger') {
      setIsActiveControl(value);
    }
  };

  return (
    <>
      <Dropdown
        key='more'
        trigger={['click']}
        menu={{
          items: [
            {
              key: 'logout',
              label: t('common:logout'),
              icon: <LogoutOutlined />,
            },
          ],
          onClick: handleDropdownClick,
        }}
        placement='bottomLeft'
        onOpenChange={handleDropdownOpenChange}>
        <Flex gap='small'>
          <UserOutlined />
          {userName}
        </Flex>
      </Dropdown>
      {isActiveControl ? contextHolder : null}
    </>
  );
};
